import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Card, Label } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Subscription from "~/models/Subscription/Subscription";
import SubscriptionStatus from "~/constants/Subscription/SubscriptionStatus";

const SubscriptionCardHeader = observer(({ t, subscription }) => (
  <Card.Header>
    <Label
      color={subscription.cancelAtPeriodEnd || subscription.status !== SubscriptionStatus.ACTIVE ? "red" : "green"}
      horizontal
    >
      {t(
        subscription.cancelAtPeriodEnd ? "billingCentral:cancellationPending" : `billingCentral:${subscription.status}`,
      )}
    </Label>
    {t("billingCentral:uiMeet3dSubscriptionId", { id: subscription.subscriptionId })}
  </Card.Header>
));

SubscriptionCardHeader.propTypes = {
  t: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription),
};

export default withTranslation()(SubscriptionCardHeader);
